import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const InputPrintPoints = ({ t, size, pointsTotal }) => {
  return (
    <div className={clsx(`input-points input-print-options input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container')}>
        <div className="input-points__empty-space" />
        <span className="input-points__points-total">
          /{pointsTotal} {!isNaN(pointsTotal) ? (pointsTotal === 1 ? t('point') : t('points')) : ' '}
        </span>
      </div>
    </div>
  );
};

InputPrintPoints.propTypes = {
  pointsTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  t: PropTypes.func,
};

export default withTranslation(['common'])(InputPrintPoints);
